import { createContext, useContext } from "react";

export const CategoriesContext = createContext({
  categories: [],
  updateCategories: () => {},
  isEmptyItems: () => {},
  fetchCategories: () => {},
  reloadCategories: () => {},
  CategoryDeletedHandler: () => {},
  ProductDeletedHandler: () => {},
  HideCategoriesSkeleton: true,
  isUpdatedCategories: false,
  categoriesError: null,
  setHideCategoriesSkeleton: () => {},
  removeCategories: () => {}
});

export const useCategoriesContext = () => useContext(CategoriesContext);
